import { render, staticRenderFns } from "./HeadingUser.vue?vue&type=template&id=bbd2f79e&scoped=true"
import script from "./HeadingUser.vue?vue&type=script&lang=js"
export * from "./HeadingUser.vue?vue&type=script&lang=js"
import style0 from "./HeadingUser.vue?vue&type=style&index=0&id=bbd2f79e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd2f79e",
  null
  
)

export default component.exports